import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { BackButton, TableData } from '../../../components';
import { errorAlert } from '../../../helpers/alerts';
import { getEmailReportHistoryService } from '../../../services/report/emailReportService';
import { Box } from '@mui/material';
import { Grid } from '@mui/system';
import { useSelector } from 'react-redux';
import moment from 'moment';
const ranges = {
  daily: 'Diario',
  weekly: 'Semanal',
  monthly: 'Mensual'
}

const types = {
  balance: 'Saldos',
  movements: 'Movimientos',
}
const EmailReportHistoryScreen = () => {
  const navigate = useNavigate();
  const { currentEmailReport } = useSelector((store) => store.emailReport);
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (!currentEmailReport) {
      navigate(-1);
      return;
    }
    setLoading(true);
    getEmailReportHistoryService(currentEmailReport.id)
      .then((response) => setHistory(response.data))
      .catch((e) => {
        errorAlert(e);
        navigate(-1);
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line
  }, [currentEmailReport?.id]);

  return (
    <Box mt={2}>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <div>
          <BackButton click={() => navigate(-1)} />
        </div>
        <div className="container-title" style={{ flexDirection: "column", textAlign: "center" }}>
          <div className="title">Historial de Reporte por Correo </div>
          <div className="subtitle">{currentEmailReport?.group?.name || currentEmailReport?.hoster?.username || "-"}</div>
          <div className="subtitle">
            {
              currentEmailReport?.range in ranges ? ranges[currentEmailReport.range] : "" + " " + currentEmailReport?.type in types ? types[currentEmailReport.type] : ""
            }
          </div>
        </div>
        <div style={{ width: "170px" }}></div>
      </Grid>
      <TableData
        dataRows={history}
        loading={loading}
        dataTitle={[
          "Fecha",
          "Estatus",
          "Correos"
        ]}
        formatter={({ createdAt, status, emails }) => [
          moment(createdAt).format("DD/MM/YYYY HH:mm:ss"),
          status || "-",
          {
            type: "text",
            value: (emails?.length ? emails?.join(", ") : "") || "-",
            maxWidth: 150
          },
        ]}
      />
    </Box>
  )
}

export default EmailReportHistoryScreen
